import { useAsyncData, useRouteParams } from '#imports'
import { computed } from 'vue'

import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { useReviewsQueryParams } from '~/scopes/reviews/reviews-display/composables/useReviewsQueryParams'
import { transformReviewsResponse } from '~/scopes/reviews/reviews-display/utils/transformReviewsResponse'

export function useSellerReviews() {
  const { uuid: id } = useRouteParams()
  const $httpFetch = useHttpFetch()
  const queryParams = useReviewsQueryParams()

  return useAsyncData(
    computed(() =>
      getAsyncDataKey('seller-reviews', {
        pathParams: { uuid: id },
        query: queryParams.value,
      }),
    ),
    () =>
      $httpFetch('/reviews/v1/sellers/:uuid/products/reviews', {
        pathParams: { uuid: id },
        query: queryParams.value,
      }),
    {
      transform: (response) => ({
        previousCursor: response.previousCursor,
        nextCursor: response.nextCursor,
        results: transformReviewsResponse(response.results),
      }),
    },
  )
}
